const UserFriendStructure = {
    userId: "",
    name: {
      first: "",
      middle: "",
      last: ""
    },
    imageUrl: "",
    gender: "",
    dateOfBirth: "", // ISO string format (e.g. "2025-01-01T00:00:00Z")
    location: "",
    friends: [
    {
      userName: "",
      userId: "",
      imageUrl: "",
      location: "",
      createdOn: "", // ISO string
      pastAbuse: false,
    }
    ],
  };
  